import { leadCreateFetch } from "@/utils/connectCounsellor";
/**
 * ============================================================================
 * BlogConnectModalForm — Service (API calls)
 * ============================================================================
 * Pure fetch wrappers matching pre-MVC utils.ts.
 * Always posts to lead-create-new. No lead-check (Blog never had one).
 * ============================================================================
 */

export interface CreateLeadOptions {
  form: Record<string, any>;
  tracking: Record<string, any>;
  ipstack: any;
  formExtra?: Record<string, any>;
}

/**
 * POST /api/salesforce.com/lead-create-new.
 * Returns the raw Response (caller parses JSON).
 */
export async function createLead({
  form,
  tracking,
  ipstack,
  formExtra,
}: CreateLeadOptions): Promise<Response> {
  return leadCreateFetch("/api/salesforce.com/lead-create-new", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ipstack,
      form: { ...form, ...formExtra },
      meta: {
        ...tracking,
        utm_medium: tracking?.utm_medium || "request_a_callback",
      },
    }),
  });
}

/** POST /api/connect-counsellor. Returns raw Response (caller parses). */
export { connectCounsellor } from "@/utils/connectCounsellor";
